module.exports = __webpack_public_path__ + "img/24.037a2503.jpg";